import React from 'react';
import classes from './PositiveTags.module.scss';

export interface PositiveTagsProps {
    tags: string[];
    selected: string[];
    onToggle: (tag: string) => void;
    title?: string;
    className?: string;
    titleClassName?: string;
    containerClassName?: string;
    chipClassName?: string;
    chipSelectedClassName?: string;
}

const PositiveTags: React.FC<PositiveTagsProps> = ({
    tags,
    selected,
    onToggle,
    title = 'What did we do best?',
    className,
    titleClassName,
    containerClassName,
    chipClassName,
    chipSelectedClassName
}) => {
    return (
        <div className={`${classes.root} ${className || ''}`.trim()}>
            <div className={titleClassName || classes.title}>{title}</div>
            <div className={containerClassName || classes.container}>
                {tags.map(tag => (
                    <button
                        type="button"
                        key={tag}
                        onClick={() => onToggle(tag)}
                        className={`${chipClassName || classes.chip} ${
                            selected.includes(tag) ? chipSelectedClassName || classes.chipSelected : ''
                        }`.trim()}
                    >
                        {tag}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default PositiveTags;
